<template>
  <div>
    <!-- Current image + service type -->
    <v-card
      flat
      class="d-flex flex-row flex-wrap"
    >
      <v-card flat>
        <v-img
          v-if="service.image"
          :src="getImage(service.image)"
          class="white--text align-end ma-2 rounded-xl"
          height="200px"
          width="300px"
          gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
          @click="$emit('update-select-image-dialog', true)"
        >
          <v-btn
            v-if="service.info_link"
            fab
            color="ppc_pink"
            x-small
            :href="service.info_link"
            target="_blank"
            top
            right
            absolute
            class="mt-7"
            @click.stop
          >
            <v-icon color="white">
              $vuetify.icons.icon_mdi_information_variant
            </v-icon>
          </v-btn>

          <v-btn
            fab
            color="ppc_pink"
            x-small
            target="_blank"
            top
            left
            absolute
            class="mt-7"
            @click.stop="removeImage"
          >
            <v-icon color="white">
              mdi-close
            </v-icon>
          </v-btn>

          <v-card-title
            class="white--text"
            v-text="service.name"
          />
        </v-img>
        <div
          v-else
          class="ma-2 rounded-xl d-flex align-center justify-center"
          style="height: 200px; width: 300px; border: 1px dashed #ccc;"
          @click="$emit('update-select-image-dialog', true)"
        >
          <span class="text--secondary">
            Select image
          </span>
        </div>
      </v-card>

    </v-card>

    <!-- Image selection dialog -->
    <v-dialog
      :value="selectImageDialog"
      @input="$emit('update-select-image-dialog', $event)"
    >
      <v-card
        flat
        class="d-flex flex-row flex-wrap"
      >
        <v-card
          v-for="(image, imageIndex) in images"
          :key="imageIndex"
          flat
        >
          <v-img
            :src="getImage(image.id)"
            class="white--text align-end"
            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
            max-height="100px"
            max-width="150px"
            @click="$emit('select-image', image.id)"
          >
            <v-card-title class="white--text">
              {{ image.name }}
            </v-card-title>
          </v-img>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'ServiceImage',

  props: {
    service: {
      type: Object,
      required: true
    },

    selectImageDialog: {
      type: Boolean,
      required: true
    },

    images: {
      type: Array,
      required: true
    },

    getImage: {
      type: Function,
      required: true
    }
  },

  methods: {

    removeImage() {
      this.$emit('remove-image')
    },
    
  }
}
</script>